import { memo } from "react";

import { cn } from "~/lib/utils";
import { type UploadedWorkspaceFile } from "../../types";

export function uploadedWorkspaceFileLabel(workspacePath: string): string {
  const segments = workspacePath.split("/").filter((segment) => segment.length > 0);
  return segments.at(-1) ?? workspacePath;
}

interface UploadedWorkspaceFileChipsProps {
  className?: string;
  files: ReadonlyArray<UploadedWorkspaceFile>;
}

export const UploadedWorkspaceFileChips = memo(function UploadedWorkspaceFileChips({
  className,
  files,
}: UploadedWorkspaceFileChipsProps) {
  if (files.length === 0) {
    return null;
  }

  return (
    <div className={cn("flex flex-wrap gap-2", className)}>
      {files.map((file) => (
        <span
          key={file.workspacePath}
          title={file.workspacePath}
          className="inline-flex max-w-full items-center rounded-full border border-border/70 bg-background/65 px-2.5 py-1 text-[11px] font-medium text-foreground/85"
        >
          <span className="truncate">{uploadedWorkspaceFileLabel(file.workspacePath)}</span>
        </span>
      ))}
    </div>
  );
});
